var _defs, _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArtboard15(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 876.31 398.23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:url(#linear-gradient-3);}.cls-3{fill:url(#linear-gradient-4);}.cls-4{fill:url(#linear-gradient-2);}.cls-5{fill:url(#linear-gradient-5);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 674.31,
    y1: 198.22,
    x2: 876.31,
    y2: 198.22,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f9c2b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#dfc0b3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#94bca5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#59b999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#2eb791"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#14b68c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#0bb68b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#048284"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006080"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 263.68,
    y1: 271.3,
    x2: 499.93,
    y2: 271.3,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 453.73,
    y1: 271.3,
    x2: 707.66,
    y2: 271.3,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -15.37,
    y1: 369.95,
    x2: 298.43,
    y2: 188.07,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 438.15,
    y1: 118.74,
    x2: 438.15,
    y2: 382.32,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#006080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#0aaf8a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#f9c2b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#026e82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#027282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#047f84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#069586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#0ab38a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#0bb68b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#7ebba0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#d6c0b1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f9c2b8"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M802.84,146.13L837.02,0h-104.19l-58.52,250.32h73.47l-34.16,146.13h104.15l58.54-250.32h-73.47Zm3.07,235.37h-73.47l34.16-146.13h-73.47L744.68,14.95h73.49l-34.18,146.13h73.47l-51.54,220.43Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M322.29,146.13l-24.21,103.38h73.49l-10.21,43.58h-73.47l-24.21,103.38h177.66l58.59-250.34h-177.64Zm107.2,235.39h-146.96l17.21-73.49h73.47l17.21-73.47h-73.49l17.21-73.49h146.94l-51.58,220.45Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M651.38,293.08l34.38-146.96h-173.5l-24.17,103.38h69.31l-10.18,43.58h-69.31l-24.17,103.38h229.76l24.17-103.38h-56.28Zm20.26,88.44h-199.08l17.19-73.49h69.31l17.19-73.47h-69.31l17.19-73.49h142.77l-34.35,146.96h56.26l-17.17,73.49Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M58.54,146.13L0,396.47H104.17l34.38-146.96h42.79l-34.38,146.96h104.17l58.54-250.34H58.54Zm180.74,235.39h-73.47l34.35-146.96H126.7l-34.38,146.96H18.85l51.54-220.45h220.43l-51.54,220.45Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M857.46,161.07l-51.54,220.43h-73.47l34.16-146.13h-73.47L744.68,14.95h73.49l-34.18,146.13h73.47Zm-523.31,0l-17.21,73.49h73.49l-17.21,73.47h-73.47l-17.21,73.49h146.96l51.58-220.45h-146.94Zm298.4,146.96l34.35-146.96h-142.77l-17.19,73.49h69.31l-17.19,73.47h-69.31l-17.19,73.49h199.08l17.17-73.49h-56.26ZM70.39,161.07L18.85,381.52H92.32l34.38-146.96h73.47l-34.35,146.96h73.47l51.54-220.45H70.39Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArtboard15);
export default __webpack_public_path__ + "static/media/Artboard 15.bca2c55186368124b5cee2a04d0d1f18.svg";
export { ForwardRef as ReactComponent };